// app/javascript/landing/pages/PortfolioPage.tsx
import React from "react";
import { SmartImage } from "../components/SmartImage";

type PortfolioItem = {
  title: string;
  tag: string;
  image: string;
};

const items: PortfolioItem[] = [
  {
    title: "Aislawall Cintac",
    tag: "XR",
    image: "/landing/portfolio/aislawall-cintac-xr.png",
  },
  {
    title: "Hotelería Modular Coya",
    tag: "XR",
    image: "/landing/portfolio/hoteleria-modular-coya-xr.png",
  },
  {
    title: "Sentina",
    tag: "Maqueta",
    image: "/landing/portfolio/sentina-maqueta-1.png",
  },
  {
    title: "Rajo Minero",
    tag: "XR",
    image: "/landing/portfolio/rajo-minero-xr.png",
  },
  {
    title: "Sentina",
    tag: "Maqueta",
    image: "/landing/portfolio/sentina-maqueta.png",
  },
  {
    title: "Aislawall Cintac",
    tag: "AR",
    image: "/landing/portfolio/aislawalll-cintac-ar.png", // ojo: 3 "l"
  },
];

export function PortfolioPage() {
  return (
    <main className="bg-white pb-48 md:pb-64">
      {/* HERO */}
      <section
        className="
          relative w-full 
          min-h-[clamp(360px,40dvh,520px)] md:min-h-[clamp(360px,70dvh,720px)]
          flex items-center
          bg-black
        "
      >
        <SmartImage
          src="/landing/portfolio/hero-bg.png"
          fill
          wrapperClassName="absolute! inset-0"
        />

        {/* Overlay oscuro tipo franja central */}
        {/* <div className="absolute inset-0 bg-gradient-to-r from-black/40 via-black/70 to-black/40" /> */}

        <div className="relative z-10 w-full max-w-5xl mx-auto px-4 md:px-6 text-center text-white space-y-12 py-16 md:py-20">
          <h1 className="text-3xl md:text-5xl font-bold tracking-[0.1em] uppercase">
            Portafolio
          </h1>
          <p className="text-sm md:text-lg max-w-2xl mx-auto">
            Una muestra de nuestros desarrollos aplicados a diferentes casos
            dentro del mundo de la construcción.
          </p>
        </div>
      </section>

      {/* GRID PORTAFOLIO */}
      <section className="py-16 md:py-20">
        <div className="max-w-6xl mx-auto px-4 md:px-6">
          <div className="grid gap-x-10 gap-y-14 sm:grid-cols-2 md:grid-cols-3">
            {items.map((item) => (
              <article key={`${item.title}-${item.tag}`} className="space-y-3">
                <div className="aspect-[4/3] overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover"
                  />
                </div>

                <div className="space-y-1">
                  <p className="font-semibold text-base md:text-lg text-purple-3">
                    {item.title}
                  </p>
                  <p className="text-sm md:text-base text-black/80">
                    {item.tag}
                  </p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}
